const DateRangeChoices = [
  { id: '*', name: 'All Dates' },
  { id: 'custom', name: 'Custom' },
  { id: 'today', name: 'Today' },
  { id: 'week', name: 'This Week' },
  { id: 'month', name: 'This Month' },
  { id: 'quarter', name: 'This Quarter' },
  { id: 'year', name: 'This Year' },
  { id: 'last_week', name: 'Last Week' },
  { id: 'last_month', name: 'Last Month' },
  { id: 'last_quarter', name: 'Last Quarter' },
  { id: '1_month', name: 'Last 30 Days' },
  { id: '6_month', name: 'Last 6 Months' },
  { id: 'last_year', name: 'Last Year' }
];

export { DateRangeChoices };
